<template>
  <Suspense>
    <CampaignCreate />
  </Suspense>
	<!--<div class="p-grid">
		<div class="p-col-12">
      <div class="p-d-flex p-mb-3">
        <h2 class="page-name p-mb-0">Add new campaign</h2>
        <Button icon="pi pi-times" class="p-button-secondary p-ml-auto" />
      </div>
      <div class="card p-px-0 p-pb-0">
        <CampaignAdd />
      </div>
		</div>
	</div>-->
</template>

<script setup>
import FormField from '../components/FormField';
import {reactive, ref, onMounted, computed} from 'vue';
import {useForm} from "../hooks/useForm";
import {useStore} from 'vuex';
import {useBrand} from '../hooks/useBrand';
import {serialize} from "object-to-formdata";
import {QueryClient, useMutation, useQuery, useQueryClient} from "vue-query";
import CampaignAdd from "../components/campaign/CampaignAdd";
import CampaignCreate from "../components/campaign/CampaignCreate";

const store = useStore();

const {submit, busy, getError, handleErrors} = useForm(async () => {



  // const response = (await updateCurrent(data)).data
  //
  // Object.assign(brand, response);
  // syncAssetsToUploader();
})

</script>

<style scoped>

</style>
